module.exports = __webpack_public_path__ + "static/media/sodaba.aee5b432.jpeg";